import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import classNames from "classnames";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@material-ui/core";
import boxScoreStyles from "../styles/BoxScore.styles";
import NoDataBox from "../../common/components/NoDataBox";

const ParticipatingPlayers = ({
	print = false,
	viewType,
	participatingPlayers
}) => {
	const classes = boxScoreStyles();

	const getPlayerPosition = (positions = []) =>
		positions
			.filter((pos) => pos)
			.map((pos) => pos.code)
			.join(" / ");

	return (
		<>
			{!participatingPlayers?.length && <NoDataBox />}
			{viewType === "grid" && (
				<Grid spacing={2} container>
					{participatingPlayers.map((player) => (
						<Grid xs={print ? 4 : 12} sm={6} md={4} lg={3} item key={player.id}>
							<Card
								className={classNames(classes.playerCard, classes.pageBreak)}
								variant="outlined"
							>
								<CardContent className={classes.playerCardContent}>
									<Typography variant="h5" component="h5">
										{player.firstName} {player.lastName}
									</Typography>
									<Typography color="textPrimary">{player.uniform}</Typography>
									<Typography color="textSecondary">
										{getPlayerPosition(player.positions)}
									</Typography>
								</CardContent>
							</Card>
						</Grid>
					))}
				</Grid>
			)}
			{viewType === "list" && (
				<TableContainer>
					<Table className={classes.tableText} aria-label="import" size="small">
						<TableHead>
							<TableRow>
								<TableCell>Number</TableCell>
								<TableCell>Name</TableCell>
								<TableCell>Position</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{participatingPlayers.map((player, i) => (
								<TableRow
									className={classNames(classes.pageBreak, {
										[classes.evenPlayerListItem]: i % 2 === 0
									})}
									key={player.id}
								>
									<TableCell>
										<Typography className={classes.textBold} color="textPrimary">
											{player.uniform}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography className={classes.textBold} color="textPrimary">
											{player.firstName} {player.lastName}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography color="textSecondary">
											{getPlayerPosition(player.positions)}
										</Typography>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</>
	);
};

// ParticipatingPlayers.whyDidYouRender = true;

export default ParticipatingPlayers;
